import { CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { FC } from 'react'
import { ReservationIdProvider } from 'src/app/hooks/context/reservationId/reservation-id.context'
import { theme } from '../../themes'

export const GuestPortalLayout: FC = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ReservationIdProvider>{children}</ReservationIdProvider>
    </ThemeProvider>
  )
}
